export default __webpack_public_path__ + "static/media/hero@2x.dab35dff.png";